import { render, staticRenderFns } from "./trial-expired-banner.vue?vue&type=template&id=83ff257e"
import script from "./trial-expired-banner.vue?vue&type=script&lang=js"
export * from "./trial-expired-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports